import React from 'react';

import { useMessage } from '@tmapy/intl';
import { Badge, Icon, SuccessBadge, SvgSpinner } from '@tmapy/style-guide';

import '../../app/components/Badge.scss';

import { SERVICE_ORDER_STATE } from '../constants';

import { serviceOrderStateMessages } from './serviceOrderMessages';

type ServiceOrderBadgeProps = {
  state: SERVICE_ORDER_STATE;
};

export const ServiceOrderBadge: React.FC<ServiceOrderBadgeProps> = ({ state }) => {
  const formatMessage = useMessage();
  const stateText = formatMessage.lookup(serviceOrderStateMessages, state) ?? state;

  switch (state) {
    case SERVICE_ORDER_STATE.PAID:
      return <SuccessBadge isStrong>{stateText}</SuccessBadge>;
    case SERVICE_ORDER_STATE.CREATED:
      return (
        <Badge unsafeClassName='dmx-badge--in-progress'>
          <div className='sg-a-d-f sg-a-ai-c'>
            <Icon element={<SvgSpinner />} />
            <span className='sg-a-ml-1/2 sg-a-ws-nw'>{stateText}</span>
          </div>
        </Badge>
      );
    case SERVICE_ORDER_STATE.DRAFT:
      return <Badge unsafeClassName='dmx-badge--muted'>{stateText}</Badge>;
    default:
      console.error('ServiceOrderBadge: Unknown state', state);
      return <>{state}</>;
  }
};
